import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import Checkout from "./routes/Checkout";
import ThankYou from "./routes/ThankYouPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/thank-you" element={<ThankYou />} />
    </Routes>
  );
}

export default App;
